var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0 L5,2 L13,2 L13,0 L15,0 L15,2 L16,2 C17.1,2 18,2.9 18,4 L18,4 L18,18 C18,19.1 17.1,20 16,20 L16,20 L2,20 C0.89,20 0,19.1 0,18 L0,18 L0.01,4 C0.01,2.9 0.89,2 2,2 L2,2 L3,2 L3,0 L5,0 Z M6,9 L4,9 L4,11 L6,11 L6,9 Z M10,9 L8,9 L8,11 L10,11 L10,9 Z M14,9 L12,9 L12,11 L14,11 L14,9 Z M16,5 L2,5 L2,7 L16,7 L16,5 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleCalendar);
export default __webpack_public_path__ + "static/media/SingleCalendar.85be0b2f8542cc9d79ba7968facd039f.svg";
export { ForwardRef as ReactComponent };